import { takeLatest, call, put } from 'redux-saga/effects';
import * as instantActions from 'redux/ducks/Employee/InstantDucks';
import * as alertActions from 'redux/ducks/common/alertDucks';
import employeeNoSessionApi from 'api/employee/employeeNoSessionApi';
import portalApi from 'api/portal/portalApi';
import { ERROR_PAGE } from 'constants/IncorporationConstants';

export function* checkPassword({ payload }) {
  try {
    const response = yield call(employeeNoSessionApi.checkPassword, payload);
    // {userId: "khk@khk.kr", pwd: "eptest$00"}
    if (response) yield put(instantActions.checkPasswordSuccess(response));
    else yield put(alertActions.open({ isDimed: true, message: ['MB_T_MB738'] }));
  } catch (error) {
    yield put(alertActions.open({ isDimed: true, message: [error.errorCode] }));
    yield put(instantActions.checkPasswordFail(error));
  }
}

export function* updateEmployee({ payload }) {
  try {
    const response = yield call(employeeNoSessionApi.updateEmployee, payload);
    yield put(instantActions.updateEmployeeSuccess(response));
  } catch (error) {
    yield put(alertActions.open({ isDimed: true, message: [error.errorMessage] }));
  }
}

export function* getLoginUser({ payload }) {
  try {
    const response = yield call(portalApi.getLoginUser, payload);
    if (response.result === 'success') yield put(instantActions.getLoginUserSuccess(response.data));
    else {
      yield put(
        alertActions.open({
          isDimed: true,
          message: [response.error.errorCode],
          callback: () => {
            window.location.href = ERROR_PAGE;
          },
        }),
      );
    }
  } catch (error) {
    yield put(
      alertActions.open({
        isDimed: true,
        message: [error.errorCode],
        callback: () => {
          window.location.href = ERROR_PAGE;
        },
      }),
    );
  }
}

export default function* AccountSaga() {
  yield takeLatest(instantActions.checkPassword, checkPassword);
  yield takeLatest(instantActions.updateEmployee, updateEmployee);
  yield takeLatest(instantActions.getLoginUser, getLoginUser);
}
